function focusVisiblePolyfill() {
  let e = [
      "Tab",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Enter",
      "Space",
      "Escape",
      "Home",
      "End",
      "PageUp",
      "PageDown",
    ],
    t = null,
    i = null;
  window.addEventListener("keydown", (t) => {
    e.includes(t.code) && (i = !1);
  }),
    window.addEventListener("mousedown", () => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        t && t.classList.remove("is-focused"),
          i || (t = document.activeElement).classList.add("is-focused");
      },
      !0
    );
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function debounce(e, t = 300) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function setHeaderHeight() {
  let e = document.querySelector(".js-header-height");
  if (!e) return;
  let t = e.offsetHeight,
    i = document.querySelector(".cc-announcement"),
    s = i ? i.offsetHeight : 0;
  (t += s),
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${s}px`
    ),
    document.documentElement.style.setProperty("--header-height", `${t}px`);
}
function setScrollbarWidth() {
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    window.innerWidth - document.documentElement.clientWidth + "px"
  );
}
function setDimensionVariables() {
  setHeaderHeight(), setScrollbarWidth();
}
function initLazyScript(e, t, i = 500) {
  if ("IntersectionObserver" in window) {
    let s = new IntersectionObserver(
      (e, i) => {
        e.forEach((e) => {
          e.isIntersecting &&
            "function" == typeof t &&
            (t(), i.unobserve(e.target));
        });
      },
      { rootMargin: `0px 0px ${i}px 0px` }
    );
    s.observe(e);
  } else t();
}
function pauseAllMedia(e = document) {
  e.querySelectorAll(".js-youtube, .js-vimeo, video").forEach((e) => {
    let t = e.closest("video-component");
    (t && "true" === t.dataset.background) ||
      (e.matches(".js-youtube")
        ? e.contentWindow.postMessage(
            '{ "event": "command", "func": "pauseVideo", "args": "" }',
            "*"
          )
        : e.matches(".js-vimeo")
        ? e.contentWindow.postMessage('{ "method": "pause" }', "*")
        : e.pause());
  }),
    e.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
(() => {
  let { mediaQueries: e } = theme;
  if (!e) return;
  let t = Object.keys(e),
    i = {};
  theme.mediaMatches = {};
  let s = () => {
    let e = t.reduce((e, t) => ((e[t] = !(!i[t] || !i[t].matches)), e), {});
    Object.keys(e).forEach((t) => {
      theme.mediaMatches[t] = e[t];
    }),
      window.dispatchEvent(new CustomEvent("on:breakpoint-change"));
  };
  t.forEach((t) => {
    (i[t] = window.matchMedia(e[t])), (theme.mediaMatches[t] = i[t].matches);
    try {
      i[t].addEventListener("change", s);
    } catch (e) {
      i[t].addListener(s);
    }
  });
})(),
  document.addEventListener("DOMContentLoaded", setDimensionVariables),
  window.addEventListener("resize", debounce(setDimensionVariables, 400));
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector(".js-load-media");
    e
      ? e.addEventListener("click", this.loadContent.bind(this))
      : this.addObserver();
  }
  addObserver() {
    if ("IntersectionObserver" in window == 0) return;
    let e = new IntersectionObserver(
      (t) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (this.loadContent(!1, !1, "observer"), e.unobserve(this));
        });
      },
      { rootMargin: "0px 0px 1000px 0px" }
    );
    e.observe(this);
  }
  loadContent(e = !0, t = !0, i = "click") {
    if ((t && pauseAllMedia(), null !== this.getAttribute("loaded"))) return;
    this.loadTrigger = i;
    let s = this.querySelector("template").content.firstElementChild.cloneNode(
      !0
    );
    this.appendChild(s), this.setAttribute("loaded", "");
    let n = this.querySelector("video, model-viewer, iframe");
    n && e && n.focus();
  }
}
customElements.define("deferred-media", DeferredMedia);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(),
      (this.disclosure = this.querySelector("details")),
      (this.toggle = this.querySelector("summary")),
      (this.panel = this.toggle.nextElementSibling),
      this.init();
  }
  init() {
    "0s" !== window.getComputedStyle(this.panel).transitionDuration &&
      (this.toggle.addEventListener("click", this.handleToggle.bind(this)),
      this.disclosure.addEventListener(
        "transitionend",
        this.handleTransitionEnd.bind(this)
      ));
  }
  handleToggle(e) {
    e.preventDefault(), this.disclosure.open ? this.close() : this.open();
  }
  handleTransitionEnd(e) {
    e.target === this.panel &&
      (this.disclosure.classList.contains("is-closing") &&
        (this.disclosure.classList.remove("is-closing"),
        (this.disclosure.open = !1)),
      this.panel.removeAttribute("style"));
  }
  addContentHeight() {
    this.panel.style.height = `${this.panel.scrollHeight}px`;
  }
  open() {
    (this.panel.style.height = "0"),
      (this.disclosure.open = !0),
      this.addContentHeight();
  }
  close() {
    this.addContentHeight(),
      this.disclosure.classList.add("is-closing"),
      setTimeout(() => {
        this.panel.style.height = "0";
      });
  }
}
customElements.define("details-disclosure", DetailsDisclosure),
  (theme.elementUtil = {}),
  (theme.elementUtil.remove = (e) => {
    e &&
      ("function" == typeof e.remove
        ? e.remove()
        : e.forEach((e) => {
            e.remove();
          }));
  }),
  (theme.elementUtil.isInViewport = (e) => {
    let t = e.getBoundingClientRect();
    return (
      Math.round(t.top) >= 0 &&
      Math.round(t.left) >= 0 &&
      Math.round(t.bottom) <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      Math.round(t.right) <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }),
  window.addEventListener(
    "resize",
    debounce(() => {
      window.dispatchEvent(new CustomEvent("on:debounced-resize"));
    })
  );
const trapFocusHandlers = {};
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function trapFocus(e, t = e) {
  let i = Array.from(
      e.querySelectorAll(
        'summary, a[href], area[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, iframe, audio[controls], video[controls], [tabindex]:not([tabindex^="-"])'
      )
    ),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target === e || t.target === n || t.target === s) &&
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = () => {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = (t) => {
      "Tab" === t.code &&
        (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()),
        (t.target === e || t.target === s) &&
          t.shiftKey &&
          (t.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    (t || e).focus();
}
class Modal extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(e) {
    (e.target === this || e.target.matches(".js-close-modal")) && this.close();
  }
  open(e) {
    (this.scrollY = window.scrollY),
      document.body.classList.add("fixed"),
      (document.body.style.top = `-${this.scrollY}px`),
      this.setAttribute("open", ""),
      (this.openedBy = e),
      trapFocus(this),
      window.pauseAllMedia(),
      (this.keyupHandler = (e) => "Escape" === e.key && this.close()),
      this.addEventListener("keyup", this.keyupHandler),
      this.querySelectorAll("table").forEach((e) => {
        let t = document.createElement("div");
        (t.className = "scrollable-table"),
          e.parentNode.insertBefore(t, e),
          t.appendChild(e);
      });
  }
  close() {
    (document.body.style.top = ""),
      document.body.classList.remove("fixed"),
      window.scrollTo(0, this.scrollY),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia(),
      this.removeEventListener("keyup", this.keyupHandler);
  }
}
customElements.define("modal-dialog", Modal);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector("button");
    e &&
      e.addEventListener("click", () => {
        let t = document.getElementById(this.dataset.modal);
        t && t.open(e);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class ProductCard extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.init.bind(this));
  }
  init() {
    (this.images = this.querySelectorAll(".card__main-image")),
      (this.links = this.querySelectorAll(".js-prod-link")),
      (this.quickAddBtn = this.querySelector(".js-quick-add")),
      (this.carouselSlider = this.querySelector("product-card-image-slider")),
      this.quickAddBtn
        ? (this.productUrl = this.quickAddBtn.dataset.productUrl)
        : this.links.length && (this.productUrl = this.links[0].href),
      this.addEventListener("change", this.handleSwatchChange.bind(this));
  }
  handleSwatchChange(e) {
    if (!e.target.matches(".opt-btn")) return;
    if (e.target.dataset.mediaId && !this.carouselSlider) {
      let t = this.querySelector(
        `[data-media-id="${e.target.dataset.mediaId}"]`
      );
      t &&
        (this.images.forEach((e) => {
          e.hidden = !0;
        }),
        (t.hidden = !1));
    }
    let t = this.productUrl.split("?").length > 1 ? "&" : "?",
      i = `${this.productUrl + t}variant=${e.target.dataset.variantId}`;
    this.links.forEach((e) => {
      e.href = i;
    }),
      this.quickAddBtn &&
        (this.quickAddBtn.dataset.selectedColor = e.target.value);
  }
}
customElements.define("product-card", ProductCard);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.init.bind(this), 500);
  }
  async init() {
    let { productId: e } = this.dataset;
    if (e)
      try {
        let t = await fetch(`${this.dataset.url}&product_id=${e}`);
        if (!t.ok) throw Error(t.status);
        let i = document.createElement("template");
        i.innerHTML = await t.text();
        let s = i.content.querySelector("product-recommendations");
        s && s.hasChildNodes() && (this.innerHTML = s.innerHTML);
      } catch (e) {
        console.log(e);
      }
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector(".qty-input__input")),
      (this.currentQty = this.input.value),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.addEventListener("click", this.handleClick.bind(this)),
      this.input.addEventListener("focus", QuantityInput.handleFocus),
      this.input.addEventListener("keydown", this.handleKeydown.bind(this));
  }
  handleClick(e) {
    e.target.matches(".qty-input__btn") &&
      (e.preventDefault(),
      (this.currentQty = this.input.value),
      "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      this.input.value !== this.currentQty &&
        (this.input.dispatchEvent(this.changeEvent),
        (this.currentQty = this.input.value)));
  }
  static handleFocus(e) {
    window.matchMedia("(pointer: fine)").matches && e.target.select();
  }
  handleKeydown(e) {
    "Enter" === e.key &&
      (e.preventDefault(),
      this.input.value !== this.currentQty &&
        (this.input.blur(),
        this.input.focus(),
        (this.currentQty = this.input.value)));
  }
}
customElements.define("quantity-input", QuantityInput);
class SideDrawer extends HTMLElement {
  constructor() {
    super(), (this.overlay = document.querySelector(".js-overlay"));
  }
  handleClick(e) {
    (e.target.matches(".js-close-drawer") || e.target === this.overlay) &&
      this.close();
  }
  open(e, t, i) {
    this.dispatchEvent(
      new CustomEvent(`on:${this.dataset.name}:before-open`, { bubbles: !0 })
    ),
      (this.scrollY = window.scrollY),
      document.body.classList.add("fixed"),
      (document.body.style.top = `-${this.scrollY}px`),
      (document.documentElement.style.height = "100svh"),
      this.overlay.classList.add("is-visible"),
      this.setAttribute("open", ""),
      this.setAttribute("aria-hidden", "false"),
      (this.opener = e),
      trapFocus(this, t),
      (this.clickHandler = this.clickHandler || this.handleClick.bind(this)),
      (this.keyupHandler = (e) => {
        "Escape" !== e.key ||
          e.target.closest(".cart-drawer-popup") ||
          this.close();
      }),
      this.addEventListener("click", this.clickHandler),
      this.addEventListener("keyup", this.keyupHandler),
      this.overlay.addEventListener("click", this.clickHandler);
    let s = parseFloat(
      getComputedStyle(this).getPropertyValue("--longest-transition-in-ms")
    );
    setTimeout(() => {
      i && i(),
        this.dispatchEvent(
          new CustomEvent(`on:${this.dataset.name}:after-open`, { bubbles: !0 })
        );
    }, s);
  }
  close(e) {
    this.dispatchEvent(
      new CustomEvent(`on:${this.dataset.name}:before-close`, { bubbles: !0 })
    ),
      this.removeAttribute("open"),
      this.setAttribute("aria-hidden", "true"),
      this.overlay.classList.remove("is-visible"),
      removeTrapFocus(this.opener),
      (document.documentElement.style.height = ""),
      (document.body.style.top = ""),
      document.body.classList.remove("fixed"),
      window.scrollTo(0, this.scrollY),
      this.removeEventListener("click", this.clickHandler),
      this.removeEventListener("keyup", this.keyupHandler),
      this.overlay.removeEventListener("click", this.clickHandler);
    let t = parseFloat(
      getComputedStyle(this).getPropertyValue("--longest-transition-in-ms")
    );
    setTimeout(() => {
      e && e(),
        this.dispatchEvent(
          new CustomEvent(`on:${this.dataset.name}:after-close`, {
            bubbles: !0,
          })
        );
    }, t);
  }
}
customElements.define("side-drawer", SideDrawer);
class CarouselSlider extends HTMLElement {
  constructor() {
    super(),
      (this.slides =
        this.querySelector(".slider__item").parentElement.children),
      this.slides.length < 2 ||
        window.initLazyScript(this, this.init.bind(this));
  }
  init() {
    (this.slider = this.querySelector(".slider")),
      (this.grid = this.querySelector(".slider__grid")),
      (this.nav = this.querySelector(
        `.slider-nav__btn[aria-controls='${this.slider.id}']`
      )?.closest(".slider-nav")),
      (this.rtl = "rtl" === document.dir),
      this.nav &&
        ((this.prevBtn = this.nav.querySelector('button[name="prev"]')),
        (this.nextBtn = this.nav.querySelector('button[name="next"]'))),
      this.initSlider(),
      window.addEventListener(
        "on:breakpoint-change",
        this.handleBreakpointChange.bind(this)
      );
  }
  initSlider() {
    if (
      ((this.gridWidth = this.grid.clientWidth),
      (this.slideSpan =
        this.getWindowOffset(this.slides[1]) -
        this.getWindowOffset(this.slides[0])),
      (this.slideGap = this.slideSpan - this.slides[0].clientWidth),
      (this.slidesPerPage = Math.round(
        (this.gridWidth + this.slideGap) / this.slideSpan
      )),
      (this.slidesToScroll =
        "page" === theme.settings.sliderItemsPerNav ? this.slidesPerPage : 1),
      (this.totalPages = this.slides.length - this.slidesPerPage + 1),
      this.setCarouselState(this.totalPages > 1),
      !(this.totalPages < 2) && this.nav)
    ) {
      if (
        ((this.sliderStart = this.getWindowOffset(this.slider)),
        this.sliderStart ||
          (this.sliderStart = (this.slider.clientWidth - this.gridWidth) / 2),
        (this.sliderEnd = this.sliderStart + this.gridWidth),
        !this.dataset.keepAnimations &&
          this.grid.querySelector("[data-cc-animate]"))
      )
        for (let e = this.slidesPerPage; e < this.slides.length; e += 1)
          this.slides[e].querySelectorAll("[data-cc-animate]").forEach((e) => {
            e.removeAttribute("data-cc-animate-delay"),
              e.classList.add("cc-animate-in");
          });
      this.addListeners(), this.setButtonStates();
    }
  }
  addListeners() {
    (this.scrollHandler = debounce(this.handleScroll.bind(this))),
      (this.navClickHandler = this.handleNavClick.bind(this)),
      this.slider.addEventListener("scroll", this.scrollHandler),
      this.nav.addEventListener("click", this.navClickHandler);
  }
  removeListeners() {
    this.slider.removeEventListener("scroll", this.scrollHandler),
      this.nav.removeEventListener("click", this.navClickHandler);
  }
  handleScroll() {
    (this.currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan)),
      this.setButtonStates();
  }
  handleNavClick(e) {
    e.target.matches(".slider-nav__btn") &&
      (("next" === e.target.name && !this.rtl) ||
      ("prev" === e.target.name && this.rtl)
        ? (this.scrollPos =
            this.slider.scrollLeft + this.slidesToScroll * this.slideSpan)
        : (this.scrollPos =
            this.slider.scrollLeft - this.slidesToScroll * this.slideSpan),
      this.slider.scrollTo({ left: this.scrollPos, behavior: "smooth" }));
  }
  handleBreakpointChange() {
    this.nav && this.removeListeners(), this.initSlider();
  }
  getWindowOffset(e) {
    return this.rtl
      ? window.innerWidth - e.getBoundingClientRect().right
      : e.getBoundingClientRect().left;
  }
  getSlideVisibility(e) {
    let t = this.getWindowOffset(e),
      i = Math.floor(t + this.slides[0].clientWidth);
    return t >= this.sliderStart && i <= Math.ceil(this.sliderEnd);
  }
  setCarouselState(e) {
    e
      ? (this.removeAttribute("inactive"),
        this.gridWidth !== this.grid.clientWidth &&
          this.handleBreakpointChange())
      : this.setAttribute("inactive", "");
  }
  setButtonStates() {
    (this.prevBtn.disabled =
      this.getSlideVisibility(this.slides[0]) && 0 === this.slider.scrollLeft),
      (this.nextBtn.disabled = this.getSlideVisibility(
        this.slides[this.slides.length - 1]
      ));
  }
}
customElements.define("carousel-slider", CarouselSlider);
class PageHeader extends HTMLElement {
  connectedCallback() {
    (this.announcement = document.querySelector(".announcement")),
      (this.header = this.querySelector(".header")),
      (this.inlineNavContainer = this.querySelector(".multi-level-nav")),
      this.inlineNavContainer &&
        ((this.inlineNav = this.querySelector(
          ".inline-header-nav .tier-1 > ul"
        )),
        (this.inlineNavMegaMenu =
          this.inlineNavContainer.querySelector("#mega-menu-tier-2"))),
      (this.touchStartTime = 0),
      (this.scrolledDown = !1),
      this.init();
  }
  init() {
    this.setAnnouncementHeight(),
      this.setScrolledState(),
      this.checkInlineNavWidth(),
      this.header.classList.contains("header--sticky") &&
        document.addEventListener("scroll", this.setScrolledState.bind(this)),
      this.inlineNavContainer &&
        (window.addEventListener("on:debounced-resize", () => {
          this.checkInlineNavWidth(),
            this.announcement && this.setAnnouncementHeight();
          let e = document.querySelector("menu-drawer");
          e.init && e.init();
        }),
        this.inlineNavMegaMenu.addEventListener("mouseenter", () =>
          clearTimeout(this.closeMenuTimeout)
        ),
        this.inlineNavMegaMenu.addEventListener(
          "mouseleave",
          this.closeChildMenu.bind(this)
        ),
        this.querySelectorAll(".contains-children").forEach((e) => {
          e.addEventListener("touchstart", this.selectNavParent.bind(this), {
            passive: !0,
          }),
            e.addEventListener("touchend", this.selectNavParent.bind(this)),
            e.addEventListener("click", this.selectNavParent.bind(this)),
            e.querySelector("a").addEventListener("keydown", (e) => {
              "Enter" === e.key && this.selectNavParent(e);
            }),
            e.addEventListener("mouseenter", (e) => {
              this.openChildMenu(e.currentTarget);
            }),
            e.addEventListener("mouseleave", this.closeChildMenu.bind(this));
        }));
  }
  selectNavParent(e) {
    if (!e.target.matches(".has-children")) return;
    let t = (e) => {
      "true" === e.querySelector("a").getAttribute("aria-expanded")
        ? this.closeChildMenu()
        : this.openChildMenu(e);
    };
    switch (e.type) {
      case "touchstart":
        this.touchStartTime = e.timeStamp;
        break;
      case "touchend":
        e.timeStamp - this.touchStartTime < 1e3 &&
          ((this.touchOpenTriggeredAt = e.timeStamp),
          t(e.currentTarget),
          e.preventDefault(),
          e.stopPropagation());
        break;
      case "click":
        e.timeStamp - this.touchOpenTriggeredAt < 1e3 &&
          (e.preventDefault(), e.stopPropagation());
        break;
      case "keydown":
        t(e.currentTarget.parentElement), e.preventDefault();
    }
  }
  openChildMenu(e) {
    if (
      (clearTimeout(this.closeMenuTimeout),
      this.inlineNavContainer
        .querySelectorAll('[aria-expanded="true"]')
        .forEach((e) => {
          e.setAttribute("aria-expanded", !1),
            this.inlineNavMegaMenu.classList.remove("tier-appeared");
        }),
      !this.imagesLoaded)
    ) {
      let t = (e) => {
        e.querySelectorAll("img[hidden]").forEach((e) => {
          (e.sizes = `${e.closest(".nav-ctas__cta").clientWidth}px`),
            e.removeAttribute("hidden");
        });
      };
      t(e), setTimeout(() => t(this), 250), (this.imagesLoaded = !0);
    }
    e.querySelector("a").setAttribute("aria-expanded", !0),
      e.classList.contains("contains-mega-menu") &&
        ((this.inlineNavMegaMenu.innerHTML = ""),
        e.childNodes.forEach((e, t) => {
          t > 1 && this.inlineNavMegaMenu.append(e.cloneNode(!0));
        }),
        this.inlineNavMegaMenu.classList.add("tier-appeared"));
  }
  closeChildMenu() {
    this.closeMenuTimeout = setTimeout(() => {
      this.inlineNavContainer
        .querySelectorAll('[aria-expanded="true"]')
        .forEach((e) => {
          e.setAttribute("aria-expanded", !1),
            this.inlineNavMegaMenu.classList.remove("tier-appeared");
        });
    }, 750);
  }
  checkInlineNavWidth() {
    "true" === this.header.dataset.navInline &&
    this.inlineNavContainer.offsetWidth > this.inlineNav.offsetWidth
      ? this.header.classList.add("header--inline-visible")
      : this.header.classList.remove("header--inline-visible");
  }
  setAnnouncementHeight() {
    this.announcementHeight = this.announcement
      ? this.announcement.clientHeight
      : 0;
  }
  setScrolledState() {
    let e = window.scrollY
      ? window.scrollY
      : -document.body.getBoundingClientRect().top;
    this.scrolledDown
      ? (clearTimeout(this.timeout),
        (this.timeout = setTimeout(
          () => {
            document.body.classList.toggle(
              "scrolled-down",
              e > this.announcementHeight
            ),
              (this.scrolledDown =
                document.body.classList.contains("scrolled-down"));
          },
          window.scrollY <= 0 ? 0 : 200
        )))
      : e > this.announcementHeight &&
        (document.body.classList.add("scrolled-down"),
        (this.scrolledDown = !0));
  }
}
if (
  (customElements.define("page-header", PageHeader),
  customElements.whenDefined("side-drawer").then(() => {
    class e extends customElements.get("side-drawer") {
      connectedCallback() {
        super.connectedCallback && super.connectedCallback(),
          (this.header = document.querySelector(".header")),
          (this.menuToggle = document.querySelector(".menu-toggle")),
          (this.mainMenuPanel = document.getElementById("main-menu-panel")),
          (this.overlay = document.querySelector(".js-header-overlay")),
          (this.menuPanelDelay = 300),
          (this.initialised = !1),
          (this.imagesLoaded = !1),
          this.header.classList.contains("header--inline-visible") ||
            this.init();
      }
      init() {
        this.initialised ||
          this.header.classList.contains("header--inline-visible") ||
          ((document.getElementById("menu-disclosure").open = !0),
          this.menuToggle.addEventListener(
            "click",
            this.handleToggleClick.bind(this)
          ),
          this.addEventListener("click", this.handleNavClick.bind(this)),
          (this.initialised = !0));
      }
      handleToggleClick(e) {
        if ((e.preventDefault(), this.hasAttribute("open"))) {
          if (this.menuToggle.classList.contains("menu-toggle--back")) {
            let e = this.getActivePanel();
            return (
              this.handleBackClick(e),
              void setTimeout(() => {
                this.getActivePanel().setAttribute("aria-hidden", "false"),
                  e.setAttribute("aria-hidden", "true");
              }, this.menuPanelDelay)
            );
          }
          this.close();
        } else
          this.open(this.menuToggle, this.querySelector(".main-menu-links a"));
      }
      handleNavClick(e) {
        let t = e.target;
        if (
          (t.matches(".child-indicator") && (t = t.parentElement),
          t.matches(".has-children > .main-menu-link"))
        ) {
          e.preventDefault(), t.setAttribute("aria-expanded", "true");
          let i = t.closest(".main-menu-panel"),
            s = document.getElementById(t.getAttribute("aria-controls"));
          i.classList.add("main-menu-panel--inactive-left"),
            i.setAttribute("aria-hidden", "true"),
            s.setAttribute("aria-hidden", "false"),
            this.menuToggle.classList.add("menu-toggle--back"),
            setTimeout(() => {
              s.classList.remove("main-menu-panel--inactive-right");
            }, this.menuPanelDelay);
        }
      }
      handleBackClick(e) {
        e.classList.add("main-menu-panel--inactive-right"),
          "main-menu-panel" === e.dataset.backId &&
            this.menuToggle.classList.remove("menu-toggle--back"),
          setTimeout(() => {
            document
              .getElementById(e.dataset.backId)
              .classList.remove("main-menu-panel--inactive-left");
          }, this.menuPanelDelay);
      }
      open() {
        this.checkMenuPadding(),
          this.imagesLoaded ||
            (this.querySelectorAll("img").forEach((e) => {
              e.hidden = !1;
            }),
            (this.imagesLoaded = !0)),
          document.body.classList.add("menu-drawer-open"),
          super.open(this);
      }
      close() {
        document.body.classList.remove("menu-drawer-open"),
          this.resetMenu(),
          super.close();
      }
      checkMenuPadding() {
        let e = this.header.offsetHeight / 2 + 42,
          t = document.querySelector(".announcement");
        t &&
          !document.body.classList.contains("scrolled-down") &&
          (e += t.offsetHeight),
          e > 90
            ? (this.style.borderTopWidth = `${e}px`)
            : this.removeAttribute("style");
      }
      getActivePanel() {
        return this.querySelector(
          ".main-menu-panel:not(.main-menu-panel--inactive-left):not(.main-menu-panel--inactive-right)"
        );
      }
      resetMenu() {
        this.menuToggle.classList.remove("menu-toggle--back"),
          setTimeout(() => {
            this.querySelectorAll(".main-menu-panel").forEach((e) => {
              e.classList.remove("main-menu-panel--inactive-left"),
                e !== this.mainMenuPanel &&
                  e.classList.add("main-menu-panel--inactive-right");
            });
          }, this.menuPanelDelay);
      }
    }
    customElements.define("menu-drawer", e);
  }),
  !customElements.get("micro-carousel"))
) {
  class e extends HTMLElement {
    connectedCallback() {
      (this.ltr = !document.querySelector("html[dir=rtl]")),
        (this.scrollContainer = this.querySelector(
          ".micro-carousel__scroll-area"
        )),
        (this.itemsContainer = this.querySelector(".micro-carousel__items")),
        (this.nextBtn = this.querySelector(".micro-carousel__next")),
        this.handleResize(),
        this.checkAtEnd(),
        (this.resizeObserver = new ResizeObserver(
          debounce(this.handleResize.bind(this), 300)
        )),
        this.resizeObserver.observe(this);
    }
    handleResize() {
      let e =
        this.itemsContainer.clientWidth > this.scrollContainer.clientWidth;
      this.isActive !== e &&
        ((this.isActive = e),
        this.isActive
          ? (this.toggleAttribute("active", !0),
            (this.nextClickHandler = this.handleClickNext.bind(this)),
            this.nextBtn.addEventListener("click", this.nextClickHandler),
            (this.scrollHandler = debounce(this.checkAtEnd.bind(this), 100)),
            this.scrollContainer.addEventListener("scroll", this.scrollHandler))
          : (this.toggleAttribute("active", !1),
            this.nextClickHandler &&
              (this.nextBtn.removeEventListener("click", this.nextClickHandler),
              (this.nextClickHandler = null)),
            this.scrollHandler &&
              (this.scrollContainer.removeEventListener(
                "scroll",
                this.scrollHandler
              ),
              (this.scrollHandler = null)))),
        this.isActive &&
          ((this.itemVisibleBoundaryBeyond = parseFloat(
            this.style.getPropertyValue("--mc-item-visible-boundary-beyond")
          )),
          Number.isNaN(this.itemVisibleBoundaryBeyond) &&
            (this.itemVisibleBoundaryBeyond = 0),
          this.checkAtEnd());
    }
    checkAtEnd() {
      (this.atEnd = this.isItemVisible(this.itemsContainer.lastElementChild)),
        this.toggleAttribute("at-end", this.atEnd);
    }
    handleClickNext(e) {
      e.preventDefault();
      let t = null;
      if ((this.atEnd && (t = this.itemsContainer.firstElementChild), !t)) {
        let e = !1;
        for (let i of this.itemsContainer.children)
          if (i.clientWidth > 1)
            if (this.isItemVisible(i)) e = !0;
            else if (e) {
              t = i;
              break;
            }
      }
      t || (t = this.itemsContainer.firstElementChild);
      let i = t.offsetLeft - this.itemsContainer.firstElementChild.offsetLeft;
      this.scrollContainer.scrollTo({ top: 0, left: i, behavior: "smooth" });
    }
    isItemVisible(e) {
      let t = Math.abs(this.scrollContainer.scrollLeft),
        i = t + this.scrollContainer.clientWidth,
        s = this.itemOffsetStart(e),
        n = s + e.offsetWidth + this.itemVisibleBoundaryBeyond;
      return s >= t && n <= i;
    }
    itemOffsetStart(e) {
      return this.ltr
        ? e.offsetLeft
        : this.scrollContainer.clientWidth - e.offsetLeft - e.clientWidth;
    }
  }
  window.customElements.define("micro-carousel", e);
}
customElements.whenDefined("side-drawer").then(() => {
  class e extends customElements.get("side-drawer") {
    connectedCallback() {
      super.connectedCallback && super.connectedCallback(),
        (this.searchToggle = document.querySelector(".header-search-toggle")),
        this.searchToggle && this.init();
    }
    init() {
      (this.overlay = document.querySelector(".js-header-overlay")),
        this.searchToggle.addEventListener("click", (e) => {
          e.preventDefault(),
            this.open(
              this.searchToggle,
              document.getElementById("search-drawer-input")
            );
        });
    }
  }
  customElements.define("search-drawer", e);
}),
  (window.initLazyScript = initLazyScript),
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(
        ".content-boundary--top, .content-boundary--top-flipped"
      )
      .forEach((e) => {
        let t = e.closest(".shopify-section");
        t.classList.add("has-content-boundary-top"),
          e.classList.contains("content-boundary--top-flipped") &&
            t.classList.add("has-content-boundary-top--flipped");
      });
  });
